import { inventoryData } from "../constants/inventoryData";
import { api } from "./api";
import { getApiOrganizationId } from "../utils/orgIdUtils";
import { inventoryEndPoints } from "../constants/endpoints";
import { Order } from "../service/cartService";

export const fecthInventoryDetails = async () => {
  try {
    return inventoryData;
  } catch (error) {
    throw new Error("Failed to fetch Inventory Data");
  }
};

export const blockInventoryApi = async (payload: Order) => {
  await api.put(inventoryEndPoints.lockInventory, payload, {
    headers: {
      orgId: getApiOrganizationId(),
    },
  });
  return true;
};

export const unblockInventoryApi = async (payload: Order) => {
  await api.put(inventoryEndPoints.unlockInventory, payload, {
    headers: {
      orgId: getApiOrganizationId(),
    },
  });
  return true;
};
